define.alias("ember-math-helpers/helpers/tanh", "settings/helpers/tanh");